module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6608d56b3dce2738b2b137569d305d3b.png";